

export default {
  name: 'HolidayOrderStatus',
  components: {
  },
  mixins: [],
  props: {
    dlvParmDt: { // 택배배송 도착예정 날짜
      type: String,
      default: ''
    },
    dlvParmWeek: { // 택배배송 도착예정 요일
      type: String,
      default: ''
    },
    holidayInfoBoxTy: {
      type: Number,
      default: 1
    }
  },
}
